export const obtenerValorReservaNinos = ({entidad, habitacion, numNoches})=>{




    let total = 0

    //Agregar Valor niños

    if (entidad.numNinos > 0){
        total = total + (entidad.numNinos * habitacion.tarifaNinos)
    }


    return total * numNoches

}